import ModalDialog from './modal-dialog';
import initUnitToggle from './unit-toggle';
import initProductMeasurements from './product-measurements';
import initMeasuringGuide from './measuring-guide';

const selectors = {
  sizeGuideTrigger: '[data-size-guide-trigger]',
  sizeGuideModal: '[data-modal-size-guide]',
};

export default function initSizeGuideModal(container) {
  // Initialise size guide modal
  const sizeGuideModalEl = container.querySelector(selectors.sizeGuideModal);
  const sizeGuideModalTriggers = container.querySelectorAll(selectors.sizeGuideTrigger);

  if (!sizeGuideModalEl || !sizeGuideModalTriggers.length) return;

  // eslint-disable-next-line no-unused-vars
  const sizeGuideModal = new ModalDialog(sizeGuideModalEl, {
    triggerEl: sizeGuideModalTriggers,
    modalId: 'size-guide',
  });

  initUnitToggle(sizeGuideModalEl);

  initProductMeasurements();

  initMeasuringGuide();
}
